// extracted by mini-css-extract-plugin
export default {"link-list":"styles_link-list__5KdIN","link-item":"styles_link-item__u-ksO","link":"styles_link__6YIkW"};